/**=========================================================
 * Module: actions.js
 * Actions Controller
 =========================================================*/

App.controller('ActionsController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";

    $scope.type = 'actionlog';
    $scope.filter = $state.params.filter;
    $scope.action = $state.params.action;

    $scope.data = [];
    $scope.elements = [];

    $scope.page = {
        title: 'entities.ACTIONLOGS',
        subTitle: ''
    };

    $scope.table = {
        type: 'actionlog',
        title: '',
        filter: true,
        fields: [
            {
            	available: true,
                name: 'T',
                type: 'date',
                format: 'YYYY-MM-DD HH:mm:ss'
            },{
                available: true,
                name: 'actionAccountGroupName',
                type: 'string'
            },{
            	available: true,
                name: 'accountName',
                type: 'string',
                hasLink: true,
                link: {
                    action: 'view',
                    type: 'user',
                    filter: 'account'
                }
            },{
            	available: true,
                name: 'action',
                type: 'string'
            }
        ]
    }

    $scope.dataToTimeline = function(scope){
        var data = scope.data;
        if(scope.action=='timeline'){
            for(var i=0; i<data.length; i++){
                var d = data[i];
                var element = {
                    title: d.action,
                    // content: d.data,
                    icon: "aqi-users",
                    left: i%2==0
                }
                scope.elements.push(element);
            }
        }
        for(var i=0; i<data.length; i++){
            var d = data[i];
            d = Object.assign(d, d.data)
        }
    }

  }
  ]);
